import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function PageHead({ titleKey, descriptionKey }) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.title = t(titleKey);
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", t(descriptionKey));
  }, [t, titleKey, descriptionKey, i18n.language]);
  return null;
}
